module.exports = __webpack_public_path__ + "static/img/30.b42e67bc.png";